import React from 'react'
import { Button, Image, Modal, Section } from '../../../components'
import Numeral from 'numeral'
import { SubmitBid } from '../constants/SubmitBid'
import { ICONS } from '../../../themes'
import { toast } from 'react-toastify'

const ModalSubmitBid = ({
  modals,
  submitStatusId,
  eventData,
  totalBidAmount,
  handlersClose,
  submitBidStatus,
  send,
  leading,
}) => {
  const biddingAmount = () => {
    let bidAmount
    if (submitStatusId === 1) {
      bidAmount = totalBidAmount
    } else if (submitStatusId === 4 || submitStatusId === 5) {
      bidAmount = leading && leading.price
    } else if (submitStatusId === 2 || submitStatusId === 3) {
      bidAmount = eventData && eventData.opening_price
    } else {
      bidAmount =
        eventData.bid_decrement_increment ||
        eventData.min_bid_decrement_increment
    }
    return Numeral(bidAmount).format('0,0.00')
  }

  const beforeBracket = () => {
    if (
      submitStatusId === 1 ||
      submitStatusId === 6 ||
      submitStatusId === 7 ||
      submitStatusId === 10 ||
      submitStatusId === 11 ||
      submitStatusId === 12 ||
      submitStatusId === 13
    ) {
      return ''
    }
    return '('
  }

  const afterBracket = () => {
    if (
      submitStatusId === 1 ||
      submitStatusId === 6 ||
      submitStatusId === 7 ||
      submitStatusId === 10 ||
      submitStatusId === 11 ||
      submitStatusId === 12 ||
      submitStatusId === 13
    ) {
      return '.'
    }
    return ').'
  }
  return (
    <Modal
      className={`${SubmitBid[submitBidStatus].theme} ${SubmitBid[submitBidStatus].modalName}`}
      isOpen={
        modals
          .filter(modal => {
            return modal.name === SubmitBid[submitBidStatus].modalName
          })
          .map(obj => obj.isOpen)[0]
      }
    >
      <Modal.Header>{SubmitBid[submitBidStatus].textTitle}</Modal.Header>
      <Modal.Body>
        <Section className={SubmitBid[submitBidStatus].bodyContent}>
          {SubmitBid[submitBidStatus] === SubmitBid.SUBMIT_BIT_STATUS.FAIL && (
            <Section className="image-warning-wrapper">
              <Image
                src={ICONS['icon-risk-score-white.svg']}
                className="icon-warning"
              />
            </Section>
          )}
          <Section className="text-detail-wrapper">
            <label>
              {`${SubmitBid[submitStatusId].header} `}
              {SubmitBid[submitStatusId].header ? <br /> : ''}
              {`${SubmitBid[submitStatusId].detail} `}
              {/*show bidding amount*/}
              <span>
                {eventData &&
                  `${beforeBracket()}${biddingAmount()} ${
                    eventData.currency
                  }${afterBracket()}`}
              </span>
              <br />
              {`${SubmitBid[submitStatusId].subDetail} `}
            </label>
          </Section>
        </Section>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="theme-gray"
          onClick={() => {
            if (submitBidStatus === SubmitBid.SUBMIT_BIT_STATUS.FAIL) {
              toast.error('Submit Bid not successfully')
            }
            handlersClose()
          }}
        >
          {SubmitBid[submitBidStatus] === SubmitBid.SUBMIT_BIT_STATUS.SUCCESS
            ? 'Cancel'
            : 'Close'}
        </Button>
        {SubmitBid[submitBidStatus].submitButton && (
          <Button className="theme-green" onClick={send}>
            OK
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default ModalSubmitBid
